// extracted by mini-css-extract-plugin
export default {"form_other":"passwordReset_form_other__EQ0pm"};